import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function QualificationSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const points = ['Sentís que perdiste el acceso al mundo de tu hijo y querés recuperarlo antes de que sea tarde.', 'Estás harta de que cada cena termine en silencio, en un portazo o en una pelea que te deja sin energía.', 'Querés dejar de trabajar gratis los domingos y feriados planificando "qué decirle" para que no se enoje.', 'Necesitás una forma profesional de demostrarle a tu hijo que estás ahí para él como guía, no como policía.'];
  return <section className="bg-cream py-20 px-4 md:px-8 lg:px-16" data-id="element-130">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-131">
        <motion.h2 initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-navy mb-10 text-center" data-id="element-132">
          ESTE PACK ES PARA VOS SI...
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-133">
          {points.map((point, index) => <motion.div key={index} variants={itemVariants} className="flex items-start space-x-4" data-id="element-134">
              <CheckCircle className="w-8 h-8 text-terracotta flex-shrink-0 mt-1" data-id="element-135" />
              <p className="text-lg md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-136">
                {point}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}